import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'

var serviceName = 'moaService'
var path = '/Moa/'
var isDebug = false

function put (http, moa) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, moa)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?moaId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search')

    return http.post(path + 'Search', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
                x.effectiveDate = dateService.convertToDate(x.effectiveDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function searchUnassigned (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'searchUnassigned')

    return http.post(path + 'SearchUnassigned', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
                x.effectiveDate = dateService.convertToDate(x.effectiveDate)
            })
        }
        return response
    })
}

function todo (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search')

    return http.post(path + 'Todo', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
                x.effectiveDate = dateService.convertToDate(x.effectiveDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

export default {
    put: put,
    get: get,
    search: search,
    searchUnassigned: searchUnassigned,
    todo: todo
}



// WEBPACK FOOTER //
// ./src/services/moaService.js